module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app grid column"
  }, [_c('app-header'), _vm._v(" "), _c('app-content')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-ece54fbe"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/app/index.vue
// module id = 62
// module chunks = 0